import useLocalStorageState from 'use-local-storage-state';
import cx from 'clsx';
import { Menu, MenuProps } from './Menu';
import { Box, Button } from '@ff-it/ui';
import { ReactElement, ReactNode } from 'react';
import * as style from './style.css';

interface SideNavProps extends MenuProps {
  branding?: ReactNode;
  children?: ReactNode;
}

export function SideNav({ menu, branding, children }: SideNavProps): ReactElement {
  const [collapsed, setCollapsed] = useLocalStorageState<boolean>('_collapse_sidebar', { defaultValue: false });
  return (
    <nav className={cx(style.sidebar, { collapsed: collapsed })}>
      <div className={style.container}>
        <div className={style.menu}>
          {!collapsed && branding}
          <Menu menu={menu} collapsed={collapsed} />
        </div>
        <Box mt="auto" textSize="xs" pt="2">
          {!collapsed && (
            <Box textAlign="center">
              {children}
              <small>{CLIENT_VERSION}</small>
            </Box>
          )}

          <Button
            variant="ghost"
            onClick={() => setCollapsed((v) => !v)}
            className={style.sidebarToggle}
            icon={`chevrons-${collapsed ? 'right' : 'left'}`}
          />
        </Box>
      </div>
    </nav>
  );
}
